// extracted by mini-css-extract-plugin
export var attribution = "_8r-4";
export var authorName = "_8r-5";
export var quote = "_8r-3";
export var testimonial = "_8r-2";
export var trustedBy = "_8r-0";
export var trustedByLabel = "_8r-1";